/* @flow */

import StyledInput from "./styled";

export default StyledInput;
